define('ie-support',['require','jquery','knockout','bowser'],function (require) {
    var $ = require('jquery');
    var ko = require('knockout');
    var bowser = require('bowser');

    if (bowser.msie && bowser.version <= 8) {
        /*
         * For IE8, the Knockout hasFocus binding throws an error if an element is not visible.
         * This overrides the default binding to make sure the element is present.
         */
        var originalHasFocusUpdate = ko.bindingHandlers.hasfocus.update;
        ko.bindingHandlers.hasfocus.update = function (element, valueAccessor) {
            if ($(element).is(':visible')) {
                originalHasFocusUpdate(element, valueAccessor);
            }
        };
    }
});

